import { lazy } from 'react';

const IIQ = lazy(() => import('../IIQ/IIQ'));
const AdvancedAgent = lazy(() => import('../../pages/advancedAgent/AdvancedAgent'));
const Adapter = lazy(() => import('../../pages/adapter/Adapter'));
const ClientHints = lazy(() => import('../../pages/clientHints/ClientHints'));
const EmptyGTM = lazy(() => import('../../pages/emptyGTM/EmptyGTM'));
const ReportTestPage = lazy(() => import('../../pages/reportTestPage/reportTestPage'));
const PerformanceData = lazy(() => import('../../pages/performanceData/PerformanceData'));
const AutomationPage = lazy(() => import('../../pages/automationPage/automaitonPage'));
const UserHintsPage = lazy(() => import('../../pages/UserHintsPage/UserHintsPage'));
const EAgent = lazy(() => import('../../pages/EAgent/EAgent'));
const ClassNamesCollision = lazy(() => import('../../pages/ClassNamesCollision/ClassNamesCollision'));
const AutoRequesterPage = lazy(() => import('../../pages/AutoRequester/AutoRequesterPage'));
const AT46Test = lazy(() => import('../../pages/at46Test/AT46test'));
const CorsPage = lazy(() => import('../../pages/corsPage/CorsPage'));
const FunctionRunnerPage = lazy(() => import('../../pages/FunctionRunnerPage/FunctionRunnerPage'));
const FlowConstructorPage = lazy(() => import('../../pages/FlowConstructorPage/FlowConstructorPage'));
const FlowParametersPage = lazy(() => import('../../pages/FlowParametersPage/FlowParametersPage'));
const AgentNodesPage = lazy(() => import('../../pages/AgentNodesPage/AgentNodesPage'));

const routes = [
    {
        path: '/',
        Component: IIQ,
        name: 'IIQ'
    },
    {
        path: '/advancedAgent',
        Component: AdvancedAgent,
        name: 'Advanced Agent'
    },
    {
        path: '/clientHints',
        Component: ClientHints,
        name: 'Client Hints'
    },
    {
        path: '/emptyGTM', // Google Tag Manager on almost empty page
        Component: EmptyGTM,
        name: 'Empty GTM'
    },
    {
        path: '/reportTestPage',
        Component: ReportTestPage,
        name: 'Report Test Page'
    },
    {
        path: '/performanceTest',
        Component: PerformanceData,
        name: 'Performance Test'
    },
    {
        path: '/automation_page/full_adapters',
        Component: AutomationPage,
        name: 'Automation Page'
    },
    {
        path: '/uh_call',
        Component: UserHintsPage,
        name: 'User Hints Page'
    }, 
    {
        path: '/class_collision',
        Component: ClassNamesCollision,
        name: 'Class collision'
    },
    {
        path: '/AutoRequesterPage',
        Component: AutoRequesterPage,
        name: 'Auto Requester'
    },
    {
        path: '/adapter',
        Component: Adapter,
        name: 'IIQ Adapter'
    },
    {
        path: '/at46test',
        Component: AT46Test,
        name: 'AT46 type'
    },
    {
        path: '/corsPage',
        Component: CorsPage,
        name: 'CORS Page'
    },
    {
        path: '/EAgent',
        Component: EAgent,
        name: 'EAgent'
    },
    {
        path: '/functionRunner',
        Component: FunctionRunnerPage,
        name: 'Function Runner'
    },
    {
        path: '/flowConstructor',
        Component: FlowConstructorPage,
        name: 'Flow Constructor'
    },
    {
        path: '/flowParameters',
        Component: FlowParametersPage,
        name: 'Flow Parameters'
    },
    {
        path: '/agent-nodes',
        Component: AgentNodesPage,
        name: 'Agent Nodes'
    }
];

export default routes;
